import React, { useEffect, useRef } from 'react';

export default function LoadMoreSentinel({ onVisible, disabled, rootSelector = '.catalogo-body' }) {
  const ref = useRef(null);

  useEffect(() => {
    if (disabled || !onVisible) return undefined;
    const el = ref.current;
    if (!el) return undefined;

    const root =
      (rootSelector && document.querySelector(rootSelector)) ||
      document.querySelector('.app-main') ||
      null;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) onVisible();
      },
      { root, rootMargin: '280px', threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [onVisible, disabled, rootSelector]);

  return <div ref={ref} className="load-more-sentinel" aria-hidden="true" />;
}
